import { RoleEnum } from '@zeus/index'
import { canImpersonate } from '~/helpers/users/can-impersonate'

export type UserAction = 'sessions' | 'edit' | 'delete' | 'impersonate' | 'resendInvitation' | 'resetCredentials'

export type UserListViewer = {
  id?: string | null
  role?: string | null
  /** Voir les parcours d'un compte (#11) : seul item du menu ouvert au formateur. */
  canViewSessions: boolean
}

type ListedUser = {
  id: string
  status: string
  email?: string | null
  username?: string | null
  role: { name: string }
}

/**
 * Les actions du menu d'une ligne, dans l'ordre d'affichage. Vide : pas de menu.
 *
 * Le formateur partage cet écran avec l'admin depuis #201, mais en lecture :
 * toutes les mutations (modification, suppression, impersonation, renvoi
 * d'invitation, réinitialisation d'identifiants) sont `@Roles(Admin)` côté API.
 * Les lui proposer ne lui donnerait que des boutons qui échouent. Ouvrir l'une
 * d'elles au formateur se décide donc des deux côtés à la fois, jamais ici seulement.
 */
export function availableUserActions(viewer: UserListViewer, user: ListedUser): UserAction[] {
  const isAdmin = viewer.role === RoleEnum.Admin
  const actions: UserAction[] = []
  if (viewer.canViewSessions) actions.push('sessions')
  if (isAdmin) actions.push('edit', 'delete')
  if (canImpersonate(viewer, { id: user.id, roleName: user.role.name })) actions.push('impersonate')
  if (isAdmin && user.status === 'PENDING_ACTIVATION' && user.email) actions.push('resendInvitation')
  // Un apprenant en pseudo (#271) n'a que ses identifiants pour se connecter.
  if (isAdmin && !user.email && user.username) actions.push('resetCredentials')
  return actions
}
